import styled from 'styled-components'

const Wrapper = styled.div`
    padding:32px;
    display:flex;
    align-items:center;
    justify-content:center;
    flex-direction: column;
`

const Icon = styled.div`
    font-size: 72px;
    margin-bottom:16px;
`

const ErrorPage = props => {
    return (
        <Wrapper>
            <Icon className="fal fa-gift"/>
            <h1>Ett fel har inträffat</h1>
            <p style={{textAlign: 'center'}}>En sektion eller formulär kan inte hittas. Detta kan bero på ett logiskt fel i formulärbyggaren.</p>

        </Wrapper>
    )
}

export default ErrorPage